// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"f132e1dc","333":"e19f07e5","599":"537289f4","762":"ed1ccc6d","768":"e19f07e5","915":"e19f07e5","976":"e19f07e5"}[chunkId] + ".chunk.css";
};